import type { TenantConfig } from '@/types/TenantConfig'

export const shinelightshow: TenantConfig = {
  logo: 'assets/shinelightshow/static/logo2.png',
  themeOptions: {
    dialog: {
      headerBackground: '#3973b1',
      headerTextColor: '#ffffff',
      headerIconColor: '#ffffff',
      headerBorder: '0',
    },
  },
  componentOptions: {
    completedOrdersRoute: {
      completedImage: {
        desktop: 'assets/shinelightshow/static/success-desktop.jpg',
        mobile: 'assets/shinelightshow/static/success-mobile.jpg',
      },
      completedContentOffset: {
        desktop: '-144px',
        mobile: '-96px',
      },
    },
  },
  teaserImageSize: {
    width: 320,
    height: 240,
  },
}
